export default [
  {
    path: "/",
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "overview" */ "@/app/modules/dashboard/dashboard.component.vue"
      ),
  },
];
